// TokenGuard.js
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import api from 'api'
import { signOut } from 'store/slices/authSlice'
import { useLocation } from 'react-router-dom'

const TokenGuard = () => {
	const dispatch = useDispatch();
    const location = useLocation();

	useEffect(() => {
		const checkToken = async () => {
			const token = localStorage.getItem('auth_token')
			if (!token) {
				dispatch(signOut())
				return
			}

			try {
				await api.get('/auth/check-token')
			} catch (error) {
				console.log('Token invalid or expired')
				dispatch(signOut())
			}
		}

		checkToken()
	}, [dispatch, location.pathname])

	return null
}

export default TokenGuard